import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Navbar />

      <main className="relative z-10 pt-28 md:pt-32 pb-20 md:pb-28">
        <div className="max-w-[820px] mx-auto px-6 md:px-10 lg:px-12">
          {/* Header */}
          <div className="mb-10 md:mb-14">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors mb-6 cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              Retour à l&apos;accueil
            </Link>
            <h1 className="font-playfair text-2xl sm:text-3xl md:text-4xl font-bold text-foreground-900">
              Politique de confidentialité
            </h1>
            <p className="text-foreground-500 text-sm mt-3">
              Dernière mise à jour : Juin 2026
            </p>
          </div>

          {/* Content */}
          <div className="space-y-10 text-foreground-800 text-[15px] leading-relaxed">
            {/* Intro */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                1. Introduction
              </h2>
              <p>
                La présente politique de confidentialité explique comment Lalou
                Maestra collecte, utilise et protège vos données personnelles
                lorsque vous naviguez sur notre site internet. Nous nous
                engageons à respecter la législation suisse en matière de
                protection des données, notamment la Loi fédérale sur la
                protection des données (nLPD).
              </p>
            </section>

            {/* Responsible */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                2. Responsable du traitement
              </h2>
              <p className="mb-2">
                Le responsable du traitement des données est :
              </p>
              <p className="text-foreground-900 font-medium">
                Lalou Maestra — Lou Vanessa Matthey
              </p>
              <p>Vevey, Suisse</p>
              <p>
                Email :{" "}
                <a
                  href="mailto:contact@laloumaestra.ch"
                  className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors"
                >
                  contact@laloumaestra.ch
                </a>
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                3. Utilisation des cookies
              </h2>
              <p className="mb-3">
                Notre site utilise des cookies afin d&apos;améliorer votre
                expérience de navigation, de mesurer l&apos;audience et de vous
                proposer des contenus adaptés. Un cookie est un petit fichier
                texte déposé sur votre terminal lors de votre visite.
              </p>

              <h3 className="font-medium text-foreground-900 mt-4 mb-2">
                Cookies essentiels
              </h3>
              <p className="mb-3">
                Ces cookies sont nécessaires au fonctionnement technique du
                site. Ils ne peuvent pas être désactivés. Ils incluent par
                exemple la mémorisation de vos préférences de consentement.
              </p>

              <h3 className="font-medium text-foreground-900 mt-4 mb-2">
                Cookies analytiques
              </h3>
              <p className="mb-3">
                Ces cookies nous permettent de mesurer l&apos;audience et de
                comprendre comment les visiteurs interagissent avec notre site,
                afin d&apos;en améliorer le contenu et l&apos;ergonomie.
              </p>

              <h3 className="font-medium text-foreground-900 mt-4 mb-2">
                Cookies marketing
              </h3>
              <p>
                Ces cookies sont utilisés pour vous proposer des contenus
                personnalisés et des offres adaptées à vos centres
                d&apos;intérêt.
              </p>
            </section>

            {/* Consent */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                4. Gestion de votre consentement
              </h2>
              <p className="mb-3">
                Lors de votre première visite, une bannière vous permet
                d&apos;accepter, de refuser ou de personnaliser vos préférences
                en matière de cookies. Vous pouvez modifier vos choix à tout
                moment en supprimant les cookies de votre navigateur ou en
                revisitant notre site, ce qui affichera à nouveau la bannière de
                consentement.
              </p>
              <p>
                Vous pouvez également configurer votre navigateur pour bloquer
                les cookies par défaut. Veuillez noter que certaines
                fonctionnalités du site pourraient être affectées.
              </p>
            </section>

            {/* Data collected */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                5. Données collectées
              </h2>
              <p className="mb-3">
                Les données susceptibles d&apos;être collectées via notre site
                incluent :
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>
                  Données de navigation (pages visitées, durée de visite,
                  interactions)
                </li>
                <li>
                  Informations transmises volontairement via nos formulaires de
                  contact (nom, email, message)
                </li>
                <li>Données techniques (adresse IP, type de navigateur)</li>
              </ul>
            </section>

            {/* Purpose */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                6. Finalités du traitement
              </h2>
              <p className="mb-3">
                Les données collectées sont utilisées pour :
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>
                  Assurer le bon fonctionnement et la sécurité du site
                </li>
                <li>Répondre à vos demandes de contact</li>
                <li>
                  Analyser l&apos;audience afin d&apos;améliorer nos services
                </li>
                <li>
                  Vous proposer des contenus pertinents (si vous y avez
                  consenti)
                </li>
              </ul>
            </section>

            {/* Rights */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                7. Vos droits
              </h2>
              <p className="mb-3">
                Conformément à la législation suisse, vous disposez des droits
                suivants concernant vos données personnelles :
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Droit d&apos;accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit d&apos;opposition au traitement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à l&apos;effacement de vos données</li>
              </ul>
              <p className="mt-3">
                Pour exercer ces droits, contactez-nous à{" "}
                <a
                  href="mailto:contact@laloumaestra.ch"
                  className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors"
                >
                  contact@laloumaestra.ch
                </a>
                .
              </p>
            </section>

            {/* Modification */}
            <section>
              <h2 className="font-playfair text-lg font-semibold text-foreground-900 mb-3">
                8. Modifications
              </h2>
              <p>
                Nous nous réservons le droit de modifier cette politique de
                confidentialité à tout moment. Les modifications entrent en
                vigueur dès leur publication sur cette page. Nous vous invitons
                à la consulter régulièrement.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}